import { createStyles, makeStyles } from '@material-ui/core/styles'
import { color } from 'src/color/color'

export const useStyles = makeStyles(theme => createStyles({
  card: {
    position: 'relative',
    overflow: 'visible',
    borderColor: color('schufa-platform-yellow'),
    borderStyle: 'solid',
    borderWidth: '10px 1px 1px 1px',
    boxShadow: 'none',
    marginTop: -theme.spacing(6),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2, 1, 0, 1),
    },
  },
  accordionItem: {
    margin: theme.spacing(4, 0),
    '&:first-child': {
      marginTop: theme.spacing(2),
    },
    '&:last-child': {
      marginBottom: theme.spacing(2),
    },
  },
  divider: {
    margin: theme.spacing(2, 0),
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(4),
    },
  },
  accordionLink: {
    cursor: 'pointer',
  },
  checkIcon: {
    color: theme.palette.success.main,
    position: 'absolute',
    width: theme.spacing(2),
    height: theme.spacing(2),
    left: -theme.spacing(2.5),
    top: theme.spacing(0.7),
  },
}))
